module.exports = __webpack_public_path__ + "static/media/affiliate-icon.8bea8827.svg";